/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import styled from '@emotion/styled';
import { tokens, Icon } from '@hotjar/hotsauce';
import { CMS } from './types';

const StyledIcon = styled.span<IntegrationsIconProps>`
  display: block;
  min-width: ${tokens.spacer.x4};
  min-height: ${tokens.spacer.x4};
  margin: 0;
  background: url('${({ icon }) => icon}') left center no-repeat;
  background-size: ${tokens.spacer.x4};
  background-position: center center;
`;

export const InstallationIcon = styled(Icon)`
  color: ${tokens.color.ember_600};
`;

export interface IntegrationsIconProps {
  icon: CMS;
  className?: string;
}

export const IntegrationsIcon = ({
  icon,
  className,
}: IntegrationsIconProps): JSX.Element | null => {
  if (icon && Object.values(CMS).includes(icon)) {
    return <StyledIcon className={className} icon={require(`./assets/${icon}.png`)} />;
  }

  return <InstallationIcon icon="code" size="l" />;
};
